export function StorageBar({ pct: p, showLabel = true }) {
  const color = p >= 80 ? "#ef4444" : p >= 50 ? "#eab308" : "#3b82f6";
  return (
    <div style={{ width: "100%" }}>
      <div
        style={{
          height: 6,
          background: "rgba(255,255,255,0.1)",
          borderRadius: 99,
          overflow: "hidden",
        }}
      >
        <div
          style={{
            height: "100%",
            width: `${p}%`,
            background: color,
            borderRadius: 99,
            transition: "width 0.6s ease",
          }}
        />
      </div>
      {showLabel && (
        <div style={{ fontSize: 11, color: "#94a3b8", marginTop: 4 }}>
          {p}% used
        </div>
      )}
    </div>
  );
}

export function StatusDot({ active }) {
  return (
    <span
      style={{
        display: "inline-block",
        width: 7,
        height: 7,
        borderRadius: 99,
        background: active ? "#22c55e" : "#ef4444",
        marginRight: 6,
      }}
    />
  );
}

export function Avatar({ name, size = 32 }) {
  const initials = name
    .split(" ")
    .map((w) => w[0])
    .join("")
    .slice(0, 2)
    .toUpperCase();
  const colors = ["#3b82f6", "#8b5cf6", "#ec4899", "#06b6d4", "#10b981"];
  const idx = name.charCodeAt(0) % colors.length;
  return (
    <div
      style={{
        width: size,
        height: size,
        borderRadius: 99,
        background: colors[idx],
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        fontSize: size * 0.35,
        fontWeight: 700,
        color: "#fff",
        fontFamily: "'Space Mono', monospace",
        flexShrink: 0,
      }}
    >
      {initials}
    </div>
  );
}

export function Tag({ children, color = "#3b82f6" }) {
  return (
    <span
      style={{
        fontSize: 11,
        fontWeight: 600,
        background: `${color}22`,
        color,
        padding: "2px 8px",
        borderRadius: 99,
        letterSpacing: "0.04em",
      }}
    >
      {children}
    </span>
  );
}
